<template>
  <div class="flex flex-row gap-2">
    <div class="aspect-w-1 aspect-h-1 w-full">
      <div v-if="loading">
        <div class="rounded-lg w-full h-full bg-gray-300 p-2 flex flex-col shadow-xl animate-pulse" />
      </div>
      <div
        v-else
        class="rounded-lg w-full p-2 flex flex-col shadow-xl"
        :style="brandColorCardStyles(color)"
      >
        <div class="text-sm bold self-start">
          {{ label }}
        </div>
        <div class="self-center p-4">
          {{ color ? color : "Not selected" }}
        </div>
      </div>
    </div>
    <div
      class="flex flex-col w-1/2 gap-2"
    >
      <div
        v-for="c in pallet"
        :key="c"
        class="flex-grow"
      >
        <div
          v-if="loading"
          class="rounded-lg w-full h-full bg-gray-300 p-2 shadow-xl animate-pulse"
        />
        <div
          v-else
          class="rounded-lg w-full p-2 h-full shadow-lg"
          :style="brandColorCardStyles(c.color)"
        >
          <div class="text-sm bold self-start">
            {{ c.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tinycolor from "tinycolor2";

export default {
  name: "ColorCard",
  props: {
    color: {
      type: String,
      default: ""
    },
    pallet: {
      type: Array,
      required: false,
      default: () => []
    },
    label: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  setup() {

  },
  computed: {

  },
  watch: {

  },
  methods: {
    // Calculates appropriate text color based on luminance
    getContrastTextColor(color) {
      const darkText = "#212121";
      const lightText = "#EBEBEB";

      const colorObj = tinycolor(color);
      if (!colorObj.isValid()) {
        return darkText;
      }

      const luminance = colorObj.getLuminance();

      return luminance > 0.5 ? darkText : lightText;
    },

    brandColorCardStyles(color){
      if(!color) color = "white";
      let style = `background-color: ${color}; `;
      style += `color: ${this.getContrastTextColor(color)}; `;
      return style;
    },
  }
};
</script>

